import { ComponentType, FC } from 'react';

import { Link } from '@material-bank/mb-uikit/components/Link';
import { UIKitLinkProps } from '@material-bank/mb-uikit/context';

export interface GenericLinkProps extends UIKitLinkProps {
  LinkComponent?: ComponentType<UIKitLinkProps>;
}

export const GenericLink: FC<GenericLinkProps> = (props, ref) => {
  const { linkSx, LinkComponent: PropLinkComponent, ...linkProps } = props;
  const LinkComponent = PropLinkComponent ?? Link;

  return <LinkComponent ref={ref} sx={linkSx} {...linkProps} />;
};
